import './index.scss'
$("header .nav li").eq(5).addClass("active");